module.exports = __webpack_public_path__ + "static/media/0023_IMG_LES_MURS_P21_UNI_MOKA_CHEVRON.b3ef1bab.png";